var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5290EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3125 12.4813C23.1536 11.1436 21.8521 9.93645 20.4313 8.88125C20.3045 8.79377 20.154 8.74692 20 8.74692C19.846 8.74692 19.6955 8.79377 19.5688 8.88125C18.1479 9.93645 16.8464 11.1436 15.6875 12.4813C13.1094 15.4344 11.75 18.5563 11.75 21.5C11.75 23.688 12.6192 25.7865 14.1664 27.3336C15.7135 28.8808 17.812 29.75 20 29.75C22.188 29.75 24.2865 28.8808 25.8336 27.3336C27.3808 25.7865 28.25 23.688 28.25 21.5C28.25 18.5563 26.8906 15.4344 24.3125 12.4813ZM25.175 22.3813C24.9932 23.453 24.482 24.4415 23.7125 25.2093C22.943 25.9771 21.9534 26.4861 20.8812 26.6656H20.7594C20.5704 26.6666 20.388 26.5961 20.2488 26.4684C20.1095 26.3407 20.0236 26.1651 20.0082 25.9768C19.9928 25.7884 20.049 25.6012 20.1657 25.4525C20.2824 25.3039 20.4509 25.2048 20.6375 25.175C21.4017 25.0471 22.1069 24.6838 22.6547 24.136C23.2026 23.5881 23.5658 22.8829 23.6937 22.1188C23.7107 22.0214 23.7468 21.9283 23.7998 21.8449C23.8529 21.7615 23.9219 21.6894 24.003 21.6328C24.084 21.5761 24.1754 21.5361 24.272 21.5149C24.3685 21.4937 24.4683 21.4918 24.5656 21.5094C24.6636 21.5252 24.7574 21.5605 24.8414 21.6132C24.9255 21.6659 24.9981 21.735 25.0549 21.8163C25.1117 21.8976 25.1517 21.9895 25.1723 22.0866C25.1929 22.1836 25.1938 22.2838 25.175 22.3813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.0776afc5744c0deee12500987420636e.svg";
export { ForwardRef as ReactComponent };